import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Keeps <head> in sync with the active language. The static tags in
// public/index.html cover crawlers and social scrapers (which never run JS);
// this only updates what a real visitor sees after switching languages.
const OG_LOCALES = { en: 'en_US', pt: 'pt_BR', es: 'es_ES' };
const HTML_LANGS = { en: 'en', pt: 'pt-BR', es: 'es' };

const setMetaContent = (selector, content) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute('content', content);
};

const Seo = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language || 'en';

  useEffect(() => {
    const lang = language.split('-')[0];
    const title = t('seo.title');
    const description = t('seo.description');

    document.title = title;
    document.documentElement.lang = HTML_LANGS[lang] || 'en';

    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[property="og:locale"]', OG_LOCALES[lang] || 'en_US');
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
  }, [t, language]);

  return null;
};

export default Seo;
